import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import { RouteErrorPage } from '@/pages/errors/route-error.page';
import { ServerErrorPage } from '@/pages/errors/server-error.page';

import { lazyRoute } from './lazy-route';
import { protectedRoutes } from './protected.routes';
import { publicRoutes } from './public.routes';

// Dev-only component gallery; the branch is statically false in prod builds,
// so the page is tree-shaken out of the bundle.
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: '/dev/components',
        lazy: lazyRoute(() => import('@/pages/dev/component-gallery.page'), 'ComponentGalleryPage'),
      },
    ]
  : [];

export const router = createBrowserRouter([
  {
    // Pathless root so a lazy/loader/render error in any descendant bubbles here
    // instead of React Router's unstyled default error page (bug 110529).
    errorElement: <RouteErrorPage />,
    children: [
      ...publicRoutes,
      ...protectedRoutes,
      ...devRoutes,
      { path: '/500', Component: ServerErrorPage },
    ],
  },
]);
